import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

/**
 * Stamp card and wheel of fortune of the customer account.
 *
 * Mirrors `src/features/loyalty/loyalty.api.ts` in the leading dashboard — same endpoints, same
 * payload shape. Only the plumbing differs (useHttp instead of TanStack Query), as this repo does.
 */
const useLoyaltyProgram = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getProgram = async () =>
    sendRequest({
      url: '/api/v1/loyaltyProgram',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });

  const getStatistics = async () =>
    sendRequest({
      url: '/api/v1/loyaltyProgram/statistics',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });

  const updateProgram = async payload =>
    sendRequest({
      url: '/api/v1/loyaltyProgram',
      method: 'PATCH',
      headers: authCtx.getAuthHeaders(),
      body: payload,
    });

  return { isLoading, error, getProgram, getStatistics, updateProgram };
};

export default useLoyaltyProgram;
